

<div class="app-container">
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
